import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const PhotoVideoPage = () => {
  return <ProductWillBeAddedSoon />;
};

export default PhotoVideoPage;
